import React, { useState } from 'react';
import { IoDiamondOutline } from "react-icons/io5";
import { FaTruckFast } from 'react-icons/fa6';
import { HiUserGroup } from 'react-icons/hi';
import { MdEmail } from 'react-icons/md';
import { FaPhoneAlt } from 'react-icons/fa';
import TransferModal from '../TransferModal/TransferModal';
import { useNavigate } from 'react-router-dom';


const TransferColumn = ({ icon: Icon, title, description }) => (
  <div className="flex flex-col p-20 border-r last:border-r-0 border-r-gray-200 shadow-2xl">
    <div className="mb-6 text-5xl text-gray-300 text-center content-center mx-auto items-center">
      <Icon />
    </div>
    <h3 className="text-xl font-semibold mb-4 Aleo text-center">{title}</h3>
    <p className="text-gray-600 text-sm leading-relaxed text-center">{description}</p>
  </div>
);


const PrivateTransfer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const transfers = [
    {
      icon: IoDiamondOutline,
      title: "Luxury Transfer Cars",
      description: "Indulge in the epitome of elegance and comfort with our fleet of luxurious transfer cars, designed to enhance your travel experience and make every journey a stylish affair."
    },
    {
      icon: FaTruckFast,
      title: "Fast & Safe Transfers",
      description: "Experience the perfect blend of speed and security with our private transfer service, ensuring fast and safe journeys to your destination."
    },
    {
      icon: HiUserGroup,
      title: "Group Transfers",
      description: "Experience seamless and luxurious group transfers in Mykonos, where ample space and comfort await, ensuring an unforgettable journey for all."
    }
  ];

  return (
    <>
      <section id='transfers' className="py-16 relative mx-auto overflow-hidden bg-gray-50">
        <div className="flex flex-col lg:flex-row gap-12  mx-auto px-8">
          {/* Left Section (Features) */}
          <div className="lg:w-3/4 grid grid-cols-1 md:grid-cols-3 border-2 shadow-2xl bg-white rounded-md border-gray-300 order-2 lg:order-1 h-fit">
            {transfers.map((transfer, index) => (
              <TransferColumn key={index} {...transfer} />
            ))}
          </div>

          {/* Right Section (CTA) */}
          <div className="lg:w-1/4 order-1 lg:order-2 flex flex-col justify-between">
            <div className="space-y-6 text-right">
              <h2 className="text-5xl Aleo">Private Transfers</h2>
              <p className="text-gray-400 text-md">
                Indulge in Luxury Private Transportation with Affordable Rates: Explore the Island in our Exquisite Fleet.
              </p>
              <hr className="w-24 border-2 border-red-500 mr-auto" />
            </div>
            
            <div className="space-y-2 mt-6 content-end flex flex-col justify-end items-end">
              <button 
                onClick={() => navigate('/transfers')}
                className="w-2/3 flex items-center justify-center gap-2 bg-gray-900 text-white px-6 py-4 rounded hover:bg-blue-900 transition-all duration-300"
              >
                <MdEmail className="text-xl" />
                <span>SEND REQUEST NOW</span>
              </button>
              
              <div className="text-red-900 font-bold">OR</div>
              
              <button 
                onClick={() => window.location.href = 'tel:+306941419012'}
                className="w-1/2 flex items-center justify-center gap-2 bg-gray-900 text-white px-6 py-4 rounded hover:bg-blue-900 transition-all duration-300">
                <FaPhoneAlt />
                <span>CALL US NOW</span>
              </button>
            </div>
          </div>
        </div>
      </section>
      
      {/* <TransferModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      /> */}
    </>
  );
};

export default PrivateTransfer;
